export const Logo = ({ className = "", alt = "Ruta 360", ...rest }) => (
  <picture>
    <source srcSet="/images/logo.webp" type="image/webp" />
    <img src="/images/logo.jpg" alt={alt} className={className} {...rest} />
  </picture>
);
